import * as SurveyActions from "src/app/store/survey/actions";
import * as ReportActions from "src/app/store/report/actions";
import * as FromSurvey from "src/app/store/survey/selectors";
import * as FromRouter from "src/app/store/router/selectors";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { SurveyDefinitionDto, SurveyDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppRoutes } from "src/app/constants";
import { RootState } from "src/app/store";
import { first, skipWhile } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { NavController } from "@ionic/angular";

@Component({
  selector: "app-history",
  templateUrl: "./history.page.html",
  styleUrls: ["./history.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryPage implements OnInit {
  public routes: typeof AppRoutes = AppRoutes;
  public loading$: Observable<boolean> = this.store.select(FromSurvey.selectLoading);
  public slug$: Observable<string> = this.store.select(FromRouter.selectSurveySlug);
  public definition$: Observable<SurveyDefinitionDto>;
  public survey$: Observable<SurveyDto>;
  public lastYearMonths: Date[];
  public breadcrumbs: { name: string; link?: string }[] = [
    { name: this.i18n.instant("DASHBOARD.BREADCRUMB_NAME"), link: `/${this.routes.home}` },
  ];

  constructor(private store: Store<RootState>, private i18n: TranslateService, private navController: NavController) {}

  public ngOnInit(): void {
    this.lastYearMonths = this.getLastYearMonths();
    this.slug$.pipe(first()).subscribe(slug => {
      this.definition$ = this.store.select(FromSurvey.selectDefinitionBySlug(slug));
      this.store.dispatch(SurveyActions.getDefinitionBySlug({ slug }));
      this.store.dispatch(ReportActions.getReportResponses({ slug }));
    });

    this.definition$
      .pipe(
        skipWhile(definition => !definition),
        first(),
      )
      .subscribe(definition => {
        this.breadcrumbs.push({ name: definition.name, link: `/${AppRoutes.reports}/${definition.slug}/${AppRoutes.history}` });
      });
  }

  public fillReport(date: Date): void {
    const month: number = date.getMonth() + 1;
    const year: number = date.getFullYear();
    this.slug$.pipe(first()).subscribe(slug => {
      this.navController.navigateForward([slug], { queryParams: { month, year } });
    });
  }

  public viewReport(date: Date): void {
    const month: number = date.getMonth() + 1;
    const year: number = date.getFullYear();
    this.slug$.pipe(first()).subscribe(slug => {
      this.navController.navigateForward([AppRoutes.reports, slug, AppRoutes.history, AppRoutes.detail], { queryParams: { month, year } });
    });
  }

  private getLastYearMonths(): Date[] {
    return Array.from({ length: 12 }, (_, index) => {
      const date = new Date();
      date.setDate(date.getDate() + 3);
      date.setMonth(date.getMonth() - (index + 1));
      return date;
    });
  }
}
